import React, { useEffect, useState } from 'react'
import { Box, Button, Checkbox, FormControlLabel, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@mui/material'
import { Item } from '../../../../common/snippets'
import * as sx from '../../../../common/stylesInline/report_daily_branch'
import LineInputV3 from '../../../../common/lineInputV3'
import EditIcon from '@mui/icons-material/Edit'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons'
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import DropDownOA from '../../../../common/dropDownOA'
import FilterAltIcon from '@mui/icons-material/FilterAlt'
import { clickElement, focusElemnt, isEmpty, navigation1, navigation3, removeDuplicatesFromArray, sortTableData } from '../../../../common/helper'
import { getFocApprovalTableData, focApprAuthDataInsert, getFocApprConsTypeData } from '../../../../../store/generalSetting/GSAction'
import { updateAlertError } from '../../../../../store/common/common_action'
import { connect } from 'react-redux'
import moment from 'moment'
import { useTranslation } from '../../../../../i18n/I18nProvider'

const FocApprovalTable = (props) => {
  const { data, getFocApprovalTableData, focApprAuthDataInsert, updateAlertError, getFocApprConsTypeData } = props
  const { common, generalSettingReducer } = data
  const { loginData } = common
  const { focApprTblData, focApprConsTypeData } = generalSettingReducer
  const { translations, language } = useTranslation()
  const gs = translations?.generalSettings || {}
  const tr = (key, fallback) => gs?.[key] || fallback
  const [tableData, setTableData] = useState(null)
  const [consType, setConsType] = useState("")
  const [authName, setAuthName] = useState("")
  const [isActive, setIsActive] = useState(true)
  const [order, setOrder] = useState('asc')
  const [orderBy, setOrderBy] = useState('')
  const [consTypeList, setConsTypeList] = useState([])
  const [filterValues, setFilterValues] = useState({});
  const [filteredData, setfilteredData] = useState(tableData)
  const [resetFilter, setResetFilter] = useState(false)
  const [manageFocus, setManageFocus] = useState(false)

  useEffect(() => {
    getTableData()
  }, [loginData])

  const getTableData = () => {
    if (!isEmpty(loginData)) {
      let object = {
        CompanyID: loginData?.intCompanyID,
        ConsSubType: 0
      }
      getFocApprovalTableData(object, true, 24 * 60 * 60 * 1000)
    }
  }

  useEffect(() => {
    if (!isEmpty(loginData)) {
      let obj = {
        intConsignmentSubTypeID: 0,
        intCompanyID: loginData?.intCompanyID,
        intConsignmentTypeID: 0,
        strSubType: "",
        intIsActive: 1,
        intIsDeleted: 0
      }
      getFocApprConsTypeData(obj)
    }
  }, [loginData])

  useEffect(() => {
    if (focApprTblData?.length > 0) {
      const data = [...focApprTblData]
      data.sort((a, b) => {
        if (a.IsActive === b.IsActive) {
          return a.SubType.localeCompare(b.SubType)
        }
        return b.IsActive - a.IsActive
      })
      let newData = data?.map((val, i) => ({ ...val, editBtn: true, ApprAuthName: val.ApprovalAuthority, active: val.IsActive }))
      setTableData(newData)
    } else {
      setTableData([])
    }
  }, [focApprTblData])

  useEffect(() => setfilteredData(tableData), [tableData])

  useEffect(() => {
    if (focApprConsTypeData?.length > 0) {
      let newData = [{ id: 0, name: tr('gsAll', 'All') }]
      focApprConsTypeData.map(function (obj) {
        newData.push({
          id: obj.ConsignmentSubTypeID,
          name: obj.SubType,
        })
      })
      newData = removeDuplicatesFromArray(newData, `id`)
      newData.sort((a, b) => a.name.localeCompare(b.name))
      setConsTypeList(newData)
      setConsType((prev) => newData.find((item) => item.id === prev?.id) || prev)
    } else {
      setConsTypeList([])
    }
  }, [focApprConsTypeData, translations])

  useEffect(() => {
    const filteredDataTemp = tableData?.filter((item) => {
      return columnDefs.every((column) => {
        const filterValue = filterValues[column.field] || "";
        const value = item[column.field]
        return filterValue ? value && value.toString().toLowerCase().includes(filterValue.toLowerCase()) : true
      })
    })
    setfilteredData(filteredDataTemp)
  }, [filterValues])

  useEffect(() => {
    setTimeout(() => {
      focusElemnt('focApprConsType')
    }, 0)
  }, [])

  const handleAdd = () => {
    if (authName === '') {
      updateAlertError({ show: true, msg: tr('pleaseEnterApprovalAuthorityName', 'Please Enter Approval Authority Name'), success: false, nextId: 'focApprAuthName' })
      return
    } else if (consType === '') {
      updateAlertError({ show: true, msg: tr('pleaseSelectTheConsignmentType', 'Please Select The Consignment Type'), success: false, nextId: 'focApprConsType' })
      return
    } else {
      let str = consTypeList.map(obj => obj.id).join('~')
      let obj = {
        CompanyID: loginData?.intCompanyID,
        ConsSubTypeIDs: consType?.id === 0 ? str : consType?.id,
        ApprovalAuthorities: authName,
        IsActive: isActive ? 1 : 0,
        UserID: loginData?.intUserID,
        ApprovalAuthorityID: 0
      }
      focApprAuthDataInsert(obj)?.then((res) => {
        if (res?.status == 'Success') {
          updateAlertError({ show: true, msg: tr('approvalAuthorityAdded', 'Approval Authority Added'), success: true, close: resetValues(), nextId: 'focApprConsType' })
        } else {
          updateAlertError({ show: true, msg: res.Message, success: false, nextId: 'focApprConsType' })
        }
      }).catch((err) => {
        console.log("Error:", err)
      })
    }
  }

  const handleRowEdit = (row, index) => {
    if (row?.ApprAuthName === '') {
      updateAlertError({ show: true, msg: tr('pleaseEnterApprovalAuthorityName', 'Please Enter Approval Authority Name'), success: false, nextId: `focApprAuthName-${index}` })
      return
    } else {
      let newVal = [...filteredData]
      let obj = {
        CompanyID: loginData?.intCompanyID,
        ConsSubTypeIDs: row?.ConsignmentSubTypeID,
        ApprovalAuthorities: row?.ApprAuthName,
        IsActive: row?.active,
        UserID: loginData?.intUserID,
        ApprovalAuthorityID: row?.ApprovalAuthorityID
      }
      focApprAuthDataInsert(obj)?.then((res) => {
        if (res?.status == 'Success') {
          updateAlertError({ show: true, msg: tr('approvalAuthorityUpdated', 'Approval Authority Updated'), success: true, close: getTableData(), nextId: 'focApprConsType' })
          if (index >= 0 && index <= newVal?.length) {
            newVal[index].editBtn = !newVal[index].editBtn
            setfilteredData(newVal)
          }
        } else {
          updateAlertError({ show: true, msg: res.Message, success: false, nextId: `focApprConsType` })
        }
      }).catch((err) => {
        console.log("Error:", err)
      })
    }
  }

  const resetValues = () => {
    setConsType('');
    setAuthName('');
    setIsActive(true);
    setResetFilter(false)
    setTimeout(() => {
      setResetFilter(true)
    }, 100);
    getTableData()
  }

  const handleChangeContain = (e, name) => {
    let value = e.target.value;
    setFilterValues((prevFilterValues) => ({
      ...prevFilterValues,
      [name]: value
    }));
  }

  const sortTable = (e, field, sortOrder, type) => {
    e.stopPropagation();
    setOrder(sortOrder);
    setOrderBy(field);
    const sortedData = sortTableData(e, field, sortOrder, type, filteredData)
    filteredData(sortedData);
  }

  const handleRowChkChange = (e, index) => {
    setManageFocus(false)
    let newVal = [...filteredData]
    if (index >= 0 && index <= newVal?.length) {
      newVal[index].active = e.target.checked ? 1 : 0
      setfilteredData(newVal)
    }
    setTimeout(() => {
      focusElemnt(`chkbox-${index}`)
    }, 0)
  }

  const handleInputChange = (e, index) => {
    let newVal = [...filteredData]
    if (index >= 0 && index <= newVal?.length) {
      newVal[index].ApprAuthName = e.target.value
      setfilteredData(newVal)
    }
  }

  const handleHideEditBtn = (index) => {
    let newVal = [...filteredData]
    if (index >= 0 && index <= newVal?.length) {
      for (let i = 0; i < newVal?.length; i++) {
        if (i === index) {
          newVal[i].editBtn = !newVal[i].editBtn
        } else {
          newVal[i].editBtn = true
        }
      }
      setfilteredData(newVal)
      focusElemnt(`editBtn-${index + 1}`)
      newVal[index].editBtn === true ? setManageFocus(false) : setManageFocus(true)
    }
  }

  const handleCrossBtn = (index) => {
    let newVal = [...filteredData]
    if (index >= 0 && index <= newVal?.length) {
      newVal[index].ApprAuthName = filteredData[index].ApprovalAuthority
      newVal[index].active = filteredData[index].IsActive
      newVal[index].editBtn = !newVal[index].editBtn
      setfilteredData(newVal)
      setTimeout(() => {
        focusElemnt(`editBtn-${index + 1}`)
      }, 0)
    }
  }

  const columnDefs = [
    { headerName: tr('gsSN', 'SN'), headerSx: { minWidth: "4%" }, field: "SN", dataType: "string", showfilter: false, allowSorting: false },
    { headerName: tr('gsCnsType', 'Consignment Type'), headerSx: { minWidth: "11%" }, field: "SubType", dataType: "string", showfilter: true, allowSorting: false },
    { headerName: tr('approvalAuthority', 'Approval Authority'), headerSx: { minWidth: "32%" }, field: "ApprAuthName", dataType: "string", showfilter: false, allowSorting: false },
    { headerName: tr('gsModBy', 'Modified By'), headerSx: { minWidth: "21%" }, field: "ModifiedUser", dataType: "string", showfilter: false, allowSorting: true },
    { headerName: tr('gsModDt', 'Modified Date & Time'), headerSx: { minWidth: "15%" }, field: "ModifedDate", dataType: "string", showfilter: false, allowSorting: true },
    { headerName: tr('gsActive', 'Active'), headerSx: { minWidth: "8%" }, field: "active", dataType: "string", showfilter: false, allowSorting: false },
    { headerName: tr('gsEdit', 'Edit'), headerSx: { minWidth: "9%" }, field: "Edit", dataType: "string", showfilter: false, allowSorting: false },
  ]

  const FocApprovalTblRow = (props) => {
    const { item, index } = props

    return (
      <TableRow key={`foc-approval-${index}`} style={{ minHeight: '40px' }}>
        <TableCell style={{ fontSize: '12px', minHeight: '40px', fontFamily: 'Roboto', fontWeight: '400', color: '#444444', padding: '0px 16px 0px 16px' }}> {index + 1} </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '40px', fontFamily: 'Roboto', fontWeight: '400', color: '#444444', padding: '0px 16px 0px 16px' }}> {item.SubType} </TableCell>
        {item.editBtn ? <TableCell style={{ fontSize: '12px', minHeight: '40px', fontFamily: 'Roboto', fontWeight: '400', color: '#444444', padding: '0px 16px 0px 16px' }}> {item.ApprovalAuthority} </TableCell> :
          <TableCell className="input--wrapper" style={{ fontSize: '12px', color: '#444444', padding: '0px 16px 0px 16px' }}>
            <Item sx={{ width: '100%', padding: '0px' }}>
              <input
                id={`focApprAuthName-${index}`}
                name={`focApprAuthName-${index}`}
                className='input--style'
                autoFocus={manageFocus}
                style={{ fontSize: "12px" }}
                value={item?.ApprAuthName || ''}
                onChange={(e) => handleInputChange(e, index)}
                onKeyDown={(e) => { navigation3(e, `chkbox-${index}`, `checkMark-${index}`) }}
              />
            </Item>
          </TableCell>}
        <TableCell style={{ fontSize: '12px', minHeight: '40px', fontFamily: 'Roboto', fontWeight: '400', color: '#444444', padding: '0px 16px 0px 16px' }}>
          <Tooltip title={`${item.ModifiedUser}, ${item.UserBranch}`}
            PopperProps={{
              sx: {
                "& .MuiTooltip-tooltip": {
                  backgroundColor: '#DAEDFE',
                  color: "#000",
                  minHeight: '26px',
                  display: 'flex',
                  fontWeight: '400',
                  alignItems: "center",
                  marginTop: '5px !important',
                  fontSize: '12px'
                }
              }
            }}
            placement="bottom-start">
            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', cursor: 'pointer', textDecoration: 'underline' }}>
              {item.ModifiedUser}
            </span>
          </Tooltip>
        </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '40px', fontFamily: 'Roboto', fontWeight: '400', color: '#444444', padding: '0px 16px 0px 16px' }}> {moment(item.ModifedDate).format("HH:mm") + ", " + moment(item.ModifedDate).format('DD-MMM-YY')} </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '40px', fontFamily: 'Roboto', fontWeight: '400', color: '#444444', padding: '0px 16px 0px 16px' }}>
          <Item className="checkbox-ctrl" style={{ width: '8%', padding: '0px', backgroundColor: 'transparent' }}>
            <FormControlLabel
              value="end"
              control={
                <Checkbox
                  id={`chkbox-${index}`}
                  checked={item.active}
                  onChange={(e) => item.editBtn ? "" : handleRowChkChange(e, index)}
                  sx={{ fontSize: '12px', backgroundColor: 'transparent !important' }}
                  onKeyDown={(e) => {
                    navigation1(e, `checkMark-${index}`, `focApprAuthName-${index}`)
                  }}
                />
              }
              labelPlacement="end"
            />
          </Item>
        </TableCell>
        <TableCell style={{ fontSize: '12px', minHeight: '40px', fontFamily: 'Roboto', fontWeight: '400', color: '#444444', padding: '0px 16px 0px 16px' }}>
          {item.editBtn ? <span id={`editBtn-${index}`} tabIndex={0} style={{ display: 'flex', color: '#007bfd', fontSize: '13px', fontWeight: 'bold', width: '52px', padding: '2px 4px', marginLeft: '-6px' }}
            onClick={() => handleHideEditBtn(index)}
            onKeyDown={(e) => navigation3(e, index === filteredData?.length - 1 ? 'focApprConsType' : `editBtn-${index + 1}`, index === 0 ? "focApprAddBtn" : `editBtn-${index - 1}`, () => { handleHideEditBtn(index) })}
          >
            <EditIcon sx={{ marginRight: '3px' }} />
            {tr('gsEdit', 'Edit')}
          </span> :
            <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', verticalAlign: 'center' }}>
              <span tabIndex={0} key={`checkMark-${index}`} id={`checkMark-${index}`} style={{ marginRight: '5px', width: '28px', padding: '1px 1px', height: '30px', marginTop: '4px' }}
                onClick={() => handleRowEdit(item, index)}
                onKeyDown={(e) => navigation3(e, `xMark-${index}`, `chkbox-${index}`, () => handleRowEdit(item, index))}

              >
                <CheckCircleOutlinedIcon tabIndex={0} style={{ color: '#4CAF50', marginTop: '1px' }} fontSize='large' />
              </span>
              <span key={`xMark-${index}`} tabIndex={0} id={`xMark-${index}`} style={{ marginRight: '5px', width: '28px', padding: '1px 1px', height: '30px', marginTop: '4px' }}
                onClick={() => handleCrossBtn(index)}
                onKeyDown={(e) => navigation3(e, `focApprAuthName-${index}`, `checkMark-${index}`, () => handleCrossBtn(index))}
              >
                <CancelOutlinedIcon tabIndex={0} style={{ color: 'red', marginTop: '1px' }} fontSize="large" />
              </span>
            </div>}
        </TableCell>
      </TableRow>
    )
  }

  const EmptyTableRow = () => {
    return (
      <TableRow>
        <TableCell colSpan={7}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '15px',
              marginBottom: '15px',
              color: 'red',
              fontSize: '14px',
            }}
          >
            <span>{tr('noResultsSelectedFilters', 'No results found for the selected filters.')}</span>
          </div>
        </TableCell>
      </TableRow>
    )
  }

  return (
    <Box>
      <Stack style={{ maxHeight: '60vh', marginTop: '10px' }}>
        <TableContainer className="lr-popup-table lrModel  scrollBlue" style={{ border: '1px solid #ddd', borderBottomLeftRadius: '0px' }} component={Paper}>
          <Table style={{ border: "none", overflow: 'auto' }} stickyHeader id="focApprovalTbl" className="table1 table-Received " size="small" aria-label="a dense table">
            <TableHead style={{ position: `sticky`, top: `0`, background: `white`, zIndex: '2' }}>
              <TableRow key='foc-tbl-header' style={{ background: '#d9edff' }}>
                {columnDefs.map((col, index) =>
                  <TableCell key={`TH-${index}`} style={{ ...col.headerSx, backgroundColor: '#DAEDFE', minHeight: '40px', fontFamily: 'Roboto', fontSize: '12px', fontWeight: '600', color: '#444444', paddingTop: "10px", paddingBottom: "8px" }}>
                    <div style={{ display: 'flex', justifyContent: "space-between" }}>
                      <span>{col.headerName}</span>
                      {col.allowSorting &&
                        <span className='SortingIcons'>
                          <span
                            className={`up ${(orderBy === col.field && order === 'asc') ? 'active' : ''}`}
                            onClick={(e) => sortTable(e, col.field, "asc", col.dataType)}
                          >
                            <FontAwesomeIcon icon={faCaretUp} transform="shrink-2" />
                          </span>
                          <span
                            className={`down ${(orderBy === col.field && order === 'desc') ? 'active' : ''}`}
                            onClick={(e) => sortTable(e, col.field, "desc", col.dataType)}
                          >
                            <FontAwesomeIcon icon={faCaretDown} transform="shrink-2" />
                          </span>
                        </span>
                      }
                    </div>
                  </TableCell>
                )}
              </TableRow>
              <TableRow key='foc-tbl-filter-row' style={{ minHeight: '40px' }} >
                <TableCell style={{ width: '4%' }} ></TableCell>
                <TableCell style={{ width: '11%' }}  >
                  <div className="filter-input" style={{ fontSize: '12px' }}>
                    <input
                      className="field"
                      name="cancelSearchInput"
                      placeholder={tr('gsContains', 'Contains')}
                      onChange={(e) => {
                        handleChangeContain(e, 'SubType')
                      }}
                      style={{ width: '100%', paddingTop: '5px' }}
                    />
                    <FilterAltIcon />
                  </div>
                </TableCell>
                <TableCell style={{ width: '32%' }} >
                  <div className="filter-input" style={{ fontSize: '12px' }}>
                    <input
                      className="field"
                      name="cancelSearchInput"
                      placeholder={tr('gsContains', 'Contains')}
                      onChange={(e) => {
                        handleChangeContain(e, 'ApprAuthName')
                      }}
                      style={{ width: '100%', paddingTop: '5px' }}
                    />
                    <FilterAltIcon />
                  </div>
                </TableCell>
                <TableCell style={{ width: '21%' }} ></TableCell>
                <TableCell style={{ width: '15%' }} ></TableCell>
                <TableCell style={{ width: '8%' }} ></TableCell>
                <TableCell style={{ width: '9%' }} ></TableCell>
              </TableRow>
            </TableHead>
            {
              filteredData?.length > 0 ?
                <>
                  <TableBody className="filter-data-row" style={{ border: "none" }}>
                    {filteredData?.map((item, index) => (
                      <FocApprovalTblRow item={item} index={index} key={index} />
                    ))}
                  </TableBody>
                </> :
                <>
                  <TableBody>
                    <EmptyTableRow />
                  </TableBody>
                </>
            }
          </Table>
        </TableContainer>
      </Stack>
      <Stack className='beachTransBottomSec' style={{ background: '#F5FAFE', top: '0px', padding: '15px 0px 11px 0px', border: '1px solid #ddd', borderBottomLeftRadius: "6px", borderBottomRightRadius: "6px", display: 'flex', flexDirection: 'row', gap: '16px' }}>
        <Item sx={sx.itemsx} style={{ width: '3%', backgroundColor: '#F5FAFE' }}></Item>
        <Item sx={sx.itemsx} style={{ width: '10%' }}>
          <DropDownOA
            key={`focApprConsType-${language}-${consType?.name}`}
            id='focApprConsType'
            label={tr('consTypeShort', 'Cons. Type')}
            data={consTypeList || []}
            defaultvalue={consType?.name || ''}
            value={consType?.name || ''}
            width="100%"
            searchPlaceholder={tr('searchConsignmentType', 'Search Consignment Type')}
            dataKey={`name`}
            idKey={`id`}
            listWidth="200px"
            resetFlag={resetFilter}
            onSelect={(val) => {
              setConsType(val)
            }}
            nextId='focApprAuthName'
            prevId={`editBtn-${filteredData?.length - 1}`}
          />
        </Item>
        <Item className="input--wrapper" sx={sx.itemsx} style={{ width: '30%' }}>
          <LineInputV3
            onKeyDown={(e) => {
              navigation3(e, 'focApprIsActive', 'focApprConsType', () => { clickElement(`focApprAuthName`) })
            }}
            autoFocus
            sx={{ width: '100%' }}
            id={`focApprAuthName`}
            label={tr('authorityName', 'Authority Name')}
            value={authName}
            onBlur={(e) => {
              setAuthName(e.target.value)
            }}
          />
        </Item>
        <Item className="input--wrapper" sx={sx.itemsx} style={{ width: '20%' }}>
          <LineInputV3
            id="focApprName"
            value={loginData?.strUserName}
            sx={{ fontSize: '14px', fontFamily: 'Roboto', fontWeight: '400' }}
            onBlur={(e) => { }}
            disabled
          />
        </Item>
        <Item className="input--wrapper" sx={sx.itemsx} style={{ width: '15%' }}>
          <LineInputV3
            id="focApprDate"
            value={moment(new Date()).format("HH:mm") + ", " + moment(new Date()).format("DD-MMM-YY")}
            sx={{ fontSize: '14px', fontFamily: 'Roboto', fontWeight: '400', color: "#444444" }}
            onBlur={(e) => { }}
            disabled
          />
        </Item>
        <Item sx={sx.itemsx} tabIndex={0} style={{ width: '7%', background: '#F5FAFE', paddingLeft: '0px' }}>
          <label htmlFor="" style={{ whiteSpace: 'nowrap', paddingLeft: '0px', fontSize: '14px', fontWeight: '400', color: "#444444" }}>
            <Checkbox
              id="focApprIsActive"
              onKeyDown={(e) => {
                navigation1(e, 'focApprAddBtn', 'focApprAuthName')
              }}
              style={{ paddingLeft: '0px' }}
              checked={isActive}
              onChange={(e) => {
                setIsActive(e.target.checked)
              }}
            />
            {tr('gsActive', 'Active')}
          </label>
        </Item>
        <Button
          id="focApprAddBtn"
          style={{ margin: '0', height: "40px" }}
          className="btn add-btn"
          variant="contained"
          color="error"
          onClick={() => { handleAdd() }}
          onKeyDown={(e) => {
            navigation1(e, `editBtn-0`, 'focApprIsActive');
          }}
        >
          {tr('gsAdd', 'add')}
        </Button>
      </Stack>
    </Box>
  )
}

const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = { getFocApprovalTableData, focApprAuthDataInsert, getFocApprConsTypeData, updateAlertError }
export default connect(mapStateToProps, mapDispatchToProps)(FocApprovalTable)


